<span> <app-price [value]="discount"></app-price></span>
